import React from 'react';
import { Autocomplete, TextField, Box } from '@mui/material';
import countries from 'world-countries';

// Transform countries data for easier use
const countryOptions = countries
  .map((country) => ({
    label: country.name.common,
    code: country.cca2, // ISO 3166-1 alpha-2 code (what Stripe expects)
    flag: country.flag,
  }))
  .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically

const CountrySelect = ({ 
  value, 
  onChange, 
  label = "Country",
  placeholder = "Select or search for a country",
  required = false,
  disabled = false,
  error = false,
  helperText,
  ...textFieldProps 
}) => {
  // Find the selected country option based on the ISO code
  const selectedCountry = value ? countryOptions.find(option => option.code === value) : null;

  const handleChange = (event, newValue) => {
    // Call onChange with the ISO country code (or null if cleared)
    onChange(newValue ? newValue.code : '');
  };

  return (
    <Autocomplete
      options={countryOptions}
      value={selectedCountry}
      onChange={handleChange}
      disabled={disabled}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option) => (
        <Box component="li" {...props} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <span style={{ fontSize: '1.2em' }}>{option.flag}</span>
          <span>{option.label}</span>
          <span style={{ color: 'text.secondary', fontSize: '0.875em' }}>({option.code})</span>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          label={label}
          placeholder={placeholder}
          required={required}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            startAdornment: selectedCountry ? (
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                <span style={{ fontSize: '1.2em' }}>{selectedCountry.flag}</span>
              </Box>
            ) : null,
          }}
        />
      )}
      filterOptions={(options, { inputValue }) => {
        const filtered = options.filter((option) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
          option.code.toLowerCase().includes(inputValue.toLowerCase())
        );
        return filtered;
      }}
    />
  );
};

export default CountrySelect; 